document.querySelectorAll('.js-toggle-password').forEach((button) => {
    const target = document.querySelector(button.dataset.target);
    const icon = button.querySelector('i');

    if (!target || !icon) {
        return;
    }

    button.addEventListener('click', () => {
        const isHidden = target.type === 'password';

        target.type = isHidden ? 'text' : 'password';
        icon.className = isHidden ? 'bi bi-eye-slash text-muted' : 'bi bi-eye text-muted';
    });
});
